import React, { useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const styles = {
  serialListContainer: {
    maxHeight: 240,
    overflowY: "auto",
    border: "1px solid",
    borderColor: "divider",
    borderRadius: 1,
    px: 1.5,
    py: 1,
    bgcolor: "background.paper",
  },
  serialRow: isLast => ({
    display: "flex",
    alignItems: "center",
    gap: 1,
    py: 0.5,
    borderBottom: isLast ? "none" : "1px solid",
    borderBottomColor: "divider",
  }),
  serialIndex: {
    minWidth: 28,
    textAlign: "right",
  },
  serialValue: {
    wordBreak: "break-word",
    flex: 1,
  },
  removeButton: {
    p: 0.5,
    ml: "auto",
  },
};

export default function SerialNumbersList({ serials, onRemove }) {
  const serialListRef = useRef(null);
  const prevSerialsLengthRef = useRef(serials?.length || 0);

  useEffect(() => {
    const prevLength = prevSerialsLengthRef.current;
    const nextLength = serials?.length || 0;
    const didAppend = nextLength > prevLength;
    prevSerialsLengthRef.current = nextLength;

    if (!didAppend) return;

    requestAnimationFrame(() => {
      const el = serialListRef.current;
      if (!el) return;
      el.scrollTop = el.scrollHeight;
    });
  }, [serials]);

  if (!serials?.length) return null;

  return (
    <>
      <Typography variant="caption" color="text.secondary">
        Serial Numbers
      </Typography>
      <Box ref={serialListRef} mt={0.5} sx={styles.serialListContainer}>
        {serials.map((serial, idx) => (
          <Box key={`${serial}-${idx}`} sx={styles.serialRow(idx === serials.length - 1)}>
            <Typography variant="body2" color="text.secondary" sx={styles.serialIndex}>
              {idx + 1}.
            </Typography>
            <Typography variant="body2" color="text.primary" sx={styles.serialValue}>
              {serial}
            </Typography>
            {onRemove && (
              <IconButton
                size="small"
                onClick={() => onRemove(idx)}
                sx={styles.removeButton}
                aria-label="Remove serial number"
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        ))}
      </Box>
    </>
  );
}
